import React, { createContext } from 'react'
import { navigate } from 'gatsby'
import * as ROUTES from '../../constants/routes'

const SearchContext = createContext(null)

class SearchContextProvider extends React.Component {
    emptyQuery = ''
    state= {
        filteredData: [],
        query: this.emptyQuery,
        value: ''
    }

    handleInputChange = event => {
        this.setState({...this.state, value: event.target.value})

        console.log(this.setState)
    }

    handleSubmit = whatever => {
        navigate(ROUTES.SEARCH)

        const query = this.state.value
        const posts = whatever || []
        const filteredData = posts.filter(post => {
            const { title, body, category } = post

            return (
                title.toLowerCase().includes(query.toLowerCase()) ||
                body.text.toLowerCase().includes(query.toLowerCase()) ||
                (category &&
                    category
                        .join('')
                        .toLowerCase()
                        .includes(query.toLowerCase()))
            )
        })

        this.setState({
            query,
            filteredData
        })
    }

    render() {
        const {children} =this.props
        const {filteredData, query, value} =this.state

    return (
        <SearchContext.Provider value={{filteredData, query, value, handleInputChange: this.handleInputChange, handleSubmit: this.handleSubmit}}>{children}</SearchContext.Provider>
    )
    }
}

export default SearchContext
export {SearchContextProvider}
